// import { Link } from '@tanstack/react-router'
import 余黃平 from 'assets/image34.jpeg'
import AI_Consulting from 'assets/aiConsulting.jpg'
// import surgeryCare from 'assets/surgeryCare.jpg'
import qr from 'assets/qr-ratetwansafe-co.svg'
import about1 from 'assets/About1-241A9729-D286-4D77-A2F4-2412DA4A1867.jpg'
import about2 from 'assets/About2-1C484247-8CB8-49D7-B4CB-7F55B96675AC.jpg'
import about3 from 'assets/About3-557A6896-AB9E-46B9-82D2-F626891EE48E.jpg'
import about4 from 'assets/About4-4BC8E28C-22BC-437B-9F2F-E617BC7BF970.jpg'
import about5 from 'assets/About5-mika-baumeis.jpg'
import testimoney1 from 'assets/IMG_2304.jpeg'
import doctorsimg from 'assets/doctors.png'
import { specialtyDefinesDisplaied } from '@/defines/specialtyDefines'
import {
    AcademicCapIcon,
    ArrowTopRightOnSquareIcon,

    CurrencyDollarIcon,
    DocumentIcon,
    ShieldCheckIcon,
    PlusSmallIcon,
    MinusSmallIcon,
    ChevronDoubleDownIcon,
    ChevronDoubleUpIcon,
    RectangleGroupIcon,
} from '@heroicons/react/24/outline'
import { Link } from 'react-router-dom'
import { useState } from 'react'
import {
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
} from '@headlessui/react'
import 'pure-react-carousel/dist/react-carousel.es.css'
import Carousel from '@/components/ui/carousel'
import Footer from '../../ui/footer'

function classNames(...classes: (string | boolean | null | undefined)[]) {
    return classes.filter(Boolean).join(' ')
}

const featuredTestimonial = {
    body: '我是一個麻醉事故的家屬，因為手術醫生要執行插管全身麻醉，不找麻醉專科醫師，加上急救處置不當與延誤，導致病患缺氧過久，成了植物人。 然而隱藏在背後的問題是執行插管麻醉的到底是手術醫師還是麻醉護理師？麻護執行插管全身麻醉是違法的密醫行為，更是嚴重危害病患的麻醉安全。 感謝「麻醉安全通」，讓我們了解醫療院所有沒有麻醉專科醫師，麻醉確實由麻醉專科醫師執行，安全才有保障。',
    author: {
        title: '麻醉事故家屬',
        name: '葉小姐',
        handle: '麻醉事故家屬',
        imageUrl: testimoney1,
    },
}

const testimonials = [
    [
        [
            {
                body: '麻醉事故頻傳，社會迫切需要一個既可以信賴又能夠輕易查看醫院診所麻醉評價的平台，因此我們整理了所有關於坊間麻醉話術、麻醉常識和麻醉安全的資訊，並與衆多麻醉科醫師合作創建了「麻醉安全通」。預防麻醉意外發生遠比事後傷痛而提起訴訟還要來得實在！「麻醉安全通」就是為你而創建的。',
                author: {
                    name: '麻醉安全特別偵查組',
                    handle: '共同創作者',
                    imageUrl:
                        'https://video.ratetwansafe.com/AnesthSafetySpecialInvestigationTeam.jpg',
                },
            },
        ],
    ],
]

const aiConsultingFeatures = [
    {
        name: '大數據不會騙人。',
        description:
            'AI 智能醫師的表達內容經由具大數據而生成，因此具備客觀、正直、可信賴的特色，可避免因巨大的經濟誘因，導致醫師更傾向於推廣不必要的治療方案。AI智能醫師將會是你更可信賴的第二諮詢醫師。',
        icon: ShieldCheckIcon,
    },
    {
        name: '協助跨越專業知識',
        description:
            '由醫療專業人員代提問人挑選用字遣詞，藉以精准掌握AI智能醫師表達的內容。',
        icon: AcademicCapIcon,
    },
    {
        name: '提供檢驗報告諮詢',
        description:
            '由提問人提供健康檢查和醫療檢驗報告，如 : 血液生化檢查、尿液檢查、放射線或核子掃描、病況等等資料，AI智能醫師將生成治療方案的建議。必要時您可以後續向我們提供更多補充信息，以確保AI智能醫生表達的內容更加準確。',
        icon: DocumentIcon,
    },
    {
        name: '免費但僅提供給合作的保險業務員',
        description:
            '本服務是完全免費的，但不接受諮詢人直接向我們提問，請聯繫您的保險業務員代為向我們提問。',
        icon: CurrencyDollarIcon,
    },
]

const videos = [
    {
        name: 'About 1',
        description:
            'AboutAboutAboutAboutAboutAboutAboutAboutAboutAboutAboutAboutAbout 1',
        url: 'https://www.youtube.com/embed/sG3ybr-PLPA?si=wu2XTau30SN74BqZ',
    },
]

const subVideoList = [
    'https://video.ratetwansafe.com/song.mp4',
    'https://video.ratetwansafe.com/soft_song.mp4',
]

const faqs = [
    {
        question: '「麻醉安全通」是透過什麼機制來認可醫院診所的麻醉醫療服務品質的呢？',
        answer: '我們是透過麻醉科醫師同仁們合力通報各醫院診所的麻醉醫療服務品質是否符合我們可以合理期待的安全程度。醫院診所本身提供實際施行麻醉的醫護人員的相關執照、證書或麻醉設施等等都不是我們參考的依據。',
    },
    {
        question: '具官方性質的醫院診所麻醉醫療品質認證和「麻醉安全通」的認可是一樣的嗎？',
        answer: '不一樣的！官方是定期式的認證，僅以醫院診所評鑑當天時醫院診所提供的麻醉安全條件為依據，但條件是可以造假的。麻醉安全通是流動式的認可，時刻都在檢查醫院診所是否滿足麻醉安全條件，一經發現不合時會即時更新資訊的。',
    },
    {
        question: '為什麼這邊的麻醉安全評價都是一樣的？',
        answer: '「隱惡揚善」是種美德，它也可以讓我們避免訟累。是的，經過我們確實調查醫院診所的麻醉醫療服務品質後，我們只有唯一的評價！之所以沒有其他評價，這⋯你懂的！',
    },
    // {
    //     question: '為什麼這裡有些醫院診所沒有麻醉安全評價呢？',
    //     answer: '因為這些醫院診所除了局部麻醉外，沒有再執行其他麻醉術式。',
    // },
    {
        question: '為什麼我找不到我要去做手術的醫院診所呢？',
        answer: '只要醫院診所和我們合作保障病人的麻醉醫療權益，網頁都會即時更新讓你可以查看得到的。',
    },
    {
        question: '如何將「麻醉安全通」放在我手機螢幕上隨時讓我點閱呢？',
        answer: 'Android谷歌搜尋麻醉安全通，按右上角「 … 」彈出表單，點選「加到主畫面」。IOS谷歌搜尋麻醉安全通，按頁頂箭頭，彈出選單在chrome中開啟，點選箭頭，加入主畫面。',
    },
]
const factsOfAnesth = [
    {
        question: '「麻醉師」是麻醉科醫師的簡稱嗎？',
        answer: '不是的！自稱「麻醉師」的人必定是「麻醉密醫」。她他們是利用「麻醉」的專業名詞、「師」的專業頭銜和猜你沒麻醉常識而誤以為她們是受過麻醉訓練，能合法地獨立為你施行麻醉的人罷了。',
    },
    {
        question: '為什麼說「自稱麻醉師」的人必定是麻醉密醫？',
        answer: '因為她他們根本就沒有醫師執照！再說既然醫師的執照很難取得，哪醫師又怎麼會不讓你知道他是醫師呢？你有聽到過「手術師、開刀師」嗎？應該沒有吧！',
    },
    {
        question: '為什麼別人總是用「麻醉師」來稱呼麻醉人員呢？',
        answer: '英文 「Anesthetist」的文義是「幫人麻醉的人」，中文籠統地將它譯為「麻醉師」，久了大家習以為常也這樣叫。不過依法從事麻醉的醫護人員，醫師稱「麻醉科醫師」，就像外科、內科醫師一樣，護理師是「麻醉科護理師」。',
    },
    {
        question: '麻醉護士或麻醉專科護理師可以幫我麻醉嗎？',
        answer: '不可以獨立地幫病人麻醉的！她們只是麻醉科醫師的助手，是協助照護手術麻醉中的病人。麻醉醫護是一個專業且分工合作的團隊，在各自的執業範疇內協同地幫病人麻醉。',
    },
    {
        question: '什麼是舒眠麻醉？只是讓我睡一覺嗎，還是把我麻醉了呢？',
        answer: '「舒眠麻醉」是「商業話術」，目的是讓你有種跟平常睡覺一樣，很舒服很安心的錯覺而欣然地接受手術。「舒眠」是行銷術語，醫療性質就是「鎮靜或全身麻醉」。',
    },
    {
        question: '鎮靜有輕度、中度、深度之分嗎？',
        answer: '有的，但那是學術上的界定，實際鎮靜時它們之間是沒有明顯分界的，這就像你走在淺灘，但往前一步就是深灘而被滅頂。鎮靜藥多加一些，輕度就會突然間地變成深度鎮靜或全身麻醉了。',
    },
    {
        question: '為什麼某些整形手術，法規規定必須由麻醉專科醫師施行而其他則不需要呢？',
        answer: '因為診所由手術醫師或所謂「麻醉師」替病人麻醉出了太多事死了人，衛福部不得不管管，所以才由相關醫學會從診所經營利益而不是從病人麻醉安全利益妥協出這樣的規定。',
    },
    {
        question: '法規說微整形、電波拉皮等小手術要麻醉時不需要麻醉專科醫師施行，這樣合理嗎？',
        answer: '不合理！手術有大小，麻醉卻無大小之分。手術和麻醉是兩回事不能混為一談。飛機有大小，但飛去美國的飛機要有執照的機師駕駛而去金門的就不要，你覺得飛去金門安全嗎？',
    },
    {
        question: '診所的人說手術時會讓我睡一下或輕度鎮靜一下，很安全的，這是真的嗎？',
        answer: '假的！事實上大多數麻醉意外都發生在這些診所和他說的睡一下或輕度鎮靜一下的手術。既然麻醉費用你都已經付過了，你別吃虧別賭命，指名由麻醉專科醫師麻醉就對了。',
    },
    {
        question: '為什麼新聞報導的麻醉意外大都是在診所發生的呢？',
        answer: '原因多重！跟欠缺麻醉設備和藥物、掛牌麻醉醫師或手術醫師掩護麻醉密醫執行麻醉、手術醫師自己手術兼麻醉、麻醉能力和人力不足、麻醉意外發生後不知所措無法及時適當處理等等都有關係。',
    },
    {
        question: '手術醫師可以幫我麻醉嗎？',
        answer: '目前只有「特管法」明訂八種整形手術必須由麻醉專科醫師全程在場親自施行麻醉，其他則任何醫師都可以幫你麻醉。但既然你都已經付過了麻醉費，堅持由麻醉專科醫師麻醉才最能保障你手術時的麻醉安全。',
    },
    {
        question: '手術醫師說他有接受過麻醉講習課或訓練且有證書可以幫我麻醉，這麻醉會安全嗎？',
        answer: '當然不安全！醫療細分專科的用意是要提升醫療品質的。接受短期麻醉訓練講習取得證書就說可以幫你麻醉是開倒車讓診所可以經營的政策，根本就不管你麻醉安不安全。證書不等同執照，麻醉專科醫師執照才貨真價實，既然你付了麻醉費，由麻醉專科醫師施行麻醉你絕對不會吃虧。',
    },
    {
        question: '為什麼麻醉一定要由麻醉專科醫師幫我麻醉才好呢？',
        answer: '你付了手術費，你希望麻醉醫師幫你做手術嗎？麻醉專科醫師是受過四年嚴格麻醉訓練養成後再經衛福部甄試合格才能取得麻醉專科執照。他們是反覆從事麻醉醫療業務並以麻醉為常業的醫師，不是來幫你做手術的。同理，手術醫師幫你麻醉，好嗎？',
    },
    {
        question: '我怎樣知道幫我麻醉的是麻醉專科醫師呢？',
        answer: '如果他她沒有先自我介紹是麻醉科醫師而你又有疑慮時，你看一下他的職員證或執業執照寫的是麻醉科、醫師還是護理師，問就更好了。不是醫師的人是不敢和你說她是醫師的。',
    },
    {
        question: '聽說麻醉意外都是病人的體質對麻醉藥過敏所造成的，那是真的嗎？',
        answer: '不一定是真的！法律有個「不可抗力」的免責條款術語，是指人們不能預見不可避免不能克服的自然現象，麻醉出事了醫師會用這個來卸責，但過敏反應並不一定不能克服。',
    },
    {
        question: '病人對麻醉藥產生過敏反應，那是非死不可嗎？',
        answer: '不一定！藥物過敏反應的醫療處置是有標準作業指引的，包括發生、發現、處置。過敏反應的發生通常是不能預見，但只要及時發現和在適當醫療處置後並不一定不能克服。',
    },
    {
        question: '麻醉同意書是什麼？',
        answer: '就是知情同意書，是有法律效力的，簽了就表示醫師已經在麻醉前有和你解釋及說明麻醉風險而你也知情並同意了。一旦麻醉出事，法官通常會認為醫師有先和你說清楚過了。',
    },
    {
        question: '醫院診所拿了份空白的麻醉同意書要我簽名，我要簽名嗎？',
        answer: '不要簽！不要隨便在任何有法律效力的文書上簽名。麻醉同意書是先由麻醉科醫師跟你說明麻醉方式、風險等讓你知情和瞭解，得到你同意了後才再由你簽名。這是法定程序！',
    },
    {
        question: '我已經先在空白的麻醉同意書上簽了名，那我現在該怎麼辦？',
        answer: '在手術前一刻你一定要見到你的麻醉科醫師請他補充說明後簽名。見不到人就表示醫院診所在呼嚨你。你已經付過麻醉費了，由麻醉科醫師替你麻醉是你的權利，付費者享受唷！',
    },
    {
        question:
            '我已經在空白的麻醉同意書上簽了名但又沒看到麻醉科醫師，那我現在該怎麼辦？',
        answer: '拒絕接受手術，另約時間下次再來。你又不是沒付麻醉費，這時候請你認真回想那些因麻醉出事而死去或變成植物人的人，你有必要吃虧又賭上你的命嗎？說不定下一個就是你！',
    },
    {
        question:
            '聽說麻醉護士受過麻醉訓練，所以她們也可以在醫師監督下替我麻醉，是真的嗎？',
        answer: '假的！麻醉護士或麻醉專科護理師，她們接受的是「麻醉護理訓練」，是協助麻醉科醫師照護手術中麻醉的病人。只有麻醉科醫師有能力而其他醫師沒有能力去監督麻醉科護理人員！',
    },
    {
        question: '有診所說他們的「麻醉師」有 ACLS 救命術證照，你可以放心？',
        answer: '你還敢放心嗎？都說的那麼明白了，是要幫你急救喔！手術中麻醉的任務可不是要幫你急救的，是要安全地讓你進入麻醉狀態，手術完成後再讓你安全地甦醒過來。',
    },
    {
        question: '麻醉專科醫師可以監督麻醉護理人員獨立施行麻醉嗎？',
        answer: '不可以！一直以來法規規定麻醉護理人員接受的只是「麻醉護理訓練」，不包括任何麻醉術式的麻醉技術在內，麻醉醫學會也不會讓她們執行這些必須由醫師親自為之的核心醫療行為。',
    },
    {
        question: '聽人說健保署並不重視手術病人的麻醉安全，那是真的嗎？',
        answer: '相當程度是真的！依現行的健保規定就只有「插管或面罩式的全身麻醉」限麻醉專科醫師才可以申報健保麻醉給付費用，其他麻醉方式任何醫師都可以申報。',
    },
    {
        question:
            '為什麼健保署不規定所有麻醉方式都限麻醉專科醫師才可以申報健保麻醉給付呢？',
        answer: '健保這種有違常理的規定是因應醫事團體利益和政治力量較量結果而訂出來的，你的麻醉安全不是健保署的重要考量因素。',
    },
    {
        question:
            '我是在健保特約醫院手術的，我該怎樣做才能保障自己的麻醉安全？',
        answer: '堅持指名麻醉科醫師替你麻醉！健保已經幫你付清麻醉費了，那是你的錢所以千萬別吃虧又賭上你的命，麻醉還是由最專業最熟練，每天反覆施行麻醉的麻醉科醫師來做吧。',
    },
    {
        question:
            '健保署在製造機會給醫院 A 健保、偽造病歷和雇用麻醉密醫，有可能嗎？',
        answer: '可能！健保只管給錢，「限或不限」某專科醫師申報是給付條件，不管醫療行為是不是由該醫師親自執行。這會發生借麻醉專科醫師執照或手術醫師掩護密醫麻醉來申報的情形。',
    },
    {
        question:
            '我是自費做手術的，診所說手術醫師或麻醉護士、「麻醉師」會幫我麻醉，這樣好嗎？',
        answer: '不好！不要管什麼法規，你不懂的，也不要聽診所怎樣說。既然你有付麻醉費就不要吃虧把命賭上，堅持由麻醉專科醫師幫你麻醉最能保障你手術時的麻醉安全！',
    },
    {
        question: '聽說台灣麻醉科醫師很缺乏，是真的嗎？',
        answer: '假的！2012.7.5前衛福部醫政司司長，現任衛福部部長石崇良就曾經在媒體公開表示過台灣不缺麻醉科醫師。十幾年過去了，今天台灣應該更不缺麻醉科醫師。',
    },
    {
        question: '麻醉意外發生後，病人家屬看到病歷書寫的事實會是真實的嗎？',
        answer: '有很大機率不是的！從麻醉意外發生到告知病人家屬通常會經過一段時間，醫院診所此時可能會修改、編造或添加適時及適當的醫療處置行為內容，甚至重新書寫麻醉記錄和病歷好為醫療糾紛強制調解或訴訟做有利的準備。',
    },
    {
        question: '聽說麻醉醫療糾紛訴訟病人或家屬都不容易贏，為什麼？',
        answer: '麻醉意外發生時你在場嗎？病歷也不一定是真實且對醫院診所是有利的。再說衛福部醫糾鑑定是以病歷為依據，而法院是書面審理為原則，即使有言詞辯論，如果在場證人一句「我忘了，不知道」或串供，你贏的機會大嗎？',
    },
]

const mainImages = [
    {
        url: doctorsimg,
        alt: "doctorsimg"
    },
    {
        url: about2,
        alt: "About image 2"
    },
]

export default function Example() {
    const [showAllFacts, setShowAllFacts] = useState(false)
    const [showAllHospital, setShowAll] = useState(false)

    const handleShowMore = () => {
        setShowAll(true)
    }

    const hospitalItemsToShow = showAllHospital
        ? specialtyDefinesDisplaied
        : specialtyDefinesDisplaied.slice(0, 7)

    const factsOfAnesthToShow = showAllFacts
        ? factsOfAnesth
        : factsOfAnesth.slice(0, 5)

    return (
        <>
            <div className="relative overflow-hidden isolate bg-gradient-to-b from-indigo-100/20">
                <div
                    className="absolute inset-y-0 right-1/2 -z-10 -mr-96 w-[200%] origin-top-right skew-x-[-30deg] bg-white shadow-xl shadow-red-400/10 ring-1 ring-indigo-50 sm:-mr-80 lg:-mr-96"
                    aria-hidden="true"
                />
                <div className="px-6 pb-10 mx-auto lg:pt-16 max-w-7xl ">
                    <div className="max-w-2xl mx-auto lg:mx-0 lg:grid lg:max-w-none lg:grid-cols-2 lg:gap-x-16 lg:gap-y-6 xl:grid-cols-1 xl:grid-rows-1 xl:gap-x-8">
                        <h1 className="max-w-2xl text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl lg:col-span-2 xl:col-auto">
                            我們的使命是：保障你手術時的麻醉安全和維護你的醫療權益
                        </h1>
                        <div className="max-w-xl mt-6 mb-6 lg:mt-0 xl:col-end-1 xl:row-start-1">
                            <p className="text-lg leading-8 text-gray-600">
                                「手術治病、麻醉保命」！我們致力提供台灣各級醫院診所的麻醉醫療服務資訊，保障你手術時的麻醉安全和維護你的醫療權益。另外你也可以透過我們的網站預約你信任的麻醉專科醫師團隊或各別麻醉專科醫師為你施行麻醉。你的麻醉安全，我們替你把關！
                            </p>
                        </div>
                        <div className="flex justify-center max-w-lg
                                rounded-2xl object-cover sm:mt-16 
                                lg:mt-0 lg:max-w-none 
                                xl:row-span-2 xl:row-end-2 xl:mt-1">
                            <Carousel
                                elements={mainImages.map(
                                    (aboutImage) =>
                                        ` 
                                    <div class="rounded-2xl overflow-hidden">
                                        <img
                                            src=${aboutImage.url}
                                            alt=${aboutImage.alt}
                                            width="700" height="415" 
                                            class="w-95 h-95 object-cover"
                                        />
                                    </div>
                                    `
                                )}
                                width={100}
                                height={100}
                            />
                        </div>

                    </div>
                </div>
                <div className="absolute inset-x-0 bottom-0 h-24 -z-10 bg-gradient-to-t from-white sm:h-32" />
            </div>

            <div className="bg-white">
                <div className="px-6 mx-auto max-w-7xl lg:px-8">
                    <div className="mx-auto lg:mx-0">
                        <h2
                            id="search"
                            className="text-2xl font-bold tracking-tight text-red-400 sm:text-3xl"
                        >
                            查看醫院診所
                        </h2>
                        <p className="pb-5 text-xl leading-8 tracking-wider text-red-400">
                            查看專科 看麻醉安全評價
                        </p>
                    </div>
                    <ul
                        role="list"
                        className="grid max-w-2xl grid-cols-2 mx-auto gap-x-8 gap-y-8 sm:grid-cols-3 lg:mx-0 lg:max-w-none lg:grid-cols-5"
                    >
                        {hospitalItemsToShow.map((specialtyDefines) => (
                            <li key={specialtyDefines.name}>
                                <Link
                                    to={
                                        '/hospital?specialty=' +
                                        specialtyDefines.enMap
                                    }
                                >
                                    <img
                                        className="aspect-[1/1] w-full rounded-2xl object-cover 
                                            xl:opacity-60 opacity-80 hover:opacity-100
                                            xl:grayscale-[20%] grayscale-[10%] hover:grayscale-[0%]"
                                        src={specialtyDefines.imageUrl}
                                        alt=""
                                    />
                                    <div className="flex justify-between">
                                        <h3 className="mt-2 text-lg font-semibold leading-8 tracking-tight text-gray-900">
                                            {specialtyDefines.name}
                                        </h3>

                                        <button
                                            type="button"
                                            className="inline-flex items-center gap-x-1.5 rounded-md 
                                                bg-red-400 px-1 mt-2 md:text-lg text-xs font-semibold text-white 
                                                shadow-sm hover:bg-red-300 focus-visible:outline focus-visible:outline-2 
                                                focus-visible:outline-offset-2 focus-visible:outline-red-600"
                                        >
                                            查看
                                            <ArrowTopRightOnSquareIcon
                                                aria-hidden="true"
                                                className="hidden w-5 h-5 md:block"
                                            />
                                        </button>
                                    </div>
                                </Link>
                            </li>
                        ))}
                        <li key="showAll">
                            {!showAllHospital && (
                                <div className="flex items-center justify-center w-full h-full">
                                    <button
                                        type="button"
                                        className="inline-flex items-center gap-x-1.5 rounded-md 
                            bg-red-400 px-3 py-2 text-sm font-semibold text-white 
                            shadow-sm hover:bg-red-300 focus-visible:outline focus-visible:outline-2 
                            focus-visible:outline-offset-2 focus-visible:outline-red-600"
                                        onClick={handleShowMore}
                                    >
                                        <RectangleGroupIcon
                                            aria-hidden="true"
                                            className="hidden w-5 h-5 md:block"
                                        />
                                        顯示全部
                                    </button>
                                </div>
                            )}
                        </li>
                    </ul>
                </div>
            </div>

            {/* Desktop */}
            <div className="hidden sm:block">

                {/*  */}
                <div className="py-6 overflow-hidden bg-white mt-10">
                    <div className="px-6 mx-auto max-w-7xl lg:px-8">
                        <Link to="https://www.youtube.com/@sharewithdoctors">
                            <p className="flex items-center text-3xl font-bold leading-8 tracking-tight text-red-400">
                                醫同分享
                                <ArrowTopRightOnSquareIcon className="w-8 h-8" />
                            </p>
                        </Link>
                        <p className="py-3 text-base tracking-wider">
                            請至醫同分享Youtube 觀看更多醫藥健康知識
                        </p>

                        <div className="flex justify-center">
                            <Carousel
                                elements={videos.map(
                                    (video) =>
                                        ` 
                                    <div className="w-screen h-screen">
                                        <iframe src=${video.url}
                                            width="700" height="415" 
                                            title="YouTube video player"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        >
                                        </iframe>
                                    </div>
                                    `
                                )}
                                width={100}
                                height={60}
                            />
                        </div>
                    </div>
                </div>


                {/* AI 智能醫師 */}
                <div className="py-6 mt-12 overflow-hidden bg-white">
                    <div className="px-6 mx-auto max-w-7xl lg:px-8">
                        <div className="grid max-w-2xl grid-cols-1 mx-auto gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
                            <div className="lg:ml-auto lg:pl-4 lg:pt-4">
                                <div className="lg:max-w-lg">
                                    <h2 className="text-base font-semibold leading-7 text-red-400">
                                        免費服務
                                    </h2>
                                    <p className="mt-2 text-3xl font-bold tracking-tight text-black sm:text-4xl">
                                        AI 醫師諮詢{' '}
                                    </p>
                                    <p className="mt-4 text-lg leading-8 text-black">
                                        客觀、正直、可信賴
                                    </p>
                                    <Disclosure
                                        key='使用說明'
                                        as="div"
                                        className="border border-red-200 rounded-lg"
                                    >
                                        <dt>
                                            {/* <Disclosure.Button className="flex w-full justify-between rounded-lg bg-purple-100 px-4 py-2 text-left text-sm font-medium text-purple-900 hover:bg-purple-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500/75">
                                                <span>What is your refund policy?</span>
                                                <ChevronUpIcon
                                                    className={`${open ? 'rotate-180 transform' : ''
                                                        } h-5 w-5 text-purple-500`}
                                                />
                                            </Disclosure.Button> */}

                                            {/* <DisclosureButton className="flex items-start justify-between w-full text-left text-gray-900 group"> */}
                                            <DisclosureButton className="group flex w-full justify-between rounded-lg px-4 py-2 text-left text-sm font-medium bg-red-100 text-red-900 hover:bg-red-200 focus:outline-none focus-visible:ring">
                                                <span className="font-semibold text-base/7">
                                                    使用說明
                                                </span>
                                                <span className="flex items-center ml-6 h-7">
                                                    <PlusSmallIcon
                                                        aria-hidden="true"
                                                        className="size-6 group-data-[open]:hidden"
                                                    />
                                                    <MinusSmallIcon
                                                        aria-hidden="true"
                                                        className="size-6 group-[&:not([data-open])]:hidden"
                                                    />
                                                </span>
                                            </DisclosureButton>
                                        </dt>
                                        <DisclosurePanel
                                            as="dd"
                                            className="pr-12 mt-2 mx-4"
                                        >
                                            <p className="text-gray-600 text-base/7">
                                                1. 請聯繫您的保險業務員，請對方產生諮詢連結給您。<br />
                                                2. 打開連結並登入後，將自動跳到諮詢畫面。<br />
                                                3. 向AI諮詢醫師提問，AI醫師收集到足夠資訊時，我們內部醫療從業人員將協助提問。通常三天內可完成。<br />
                                                4. 醫療從業人員詢問AI醫師完畢後，將把報表回傳給您。<br />
                                                5. 完成! AI 醫師已根據您的輸入，提供客觀、正直、可信賴的建議和資訊。<br />
                                            </p>
                                        </DisclosurePanel>
                                    </Disclosure>

                                    <dl className="max-w-xl mt-6 space-y-8 text-base leading-7 text-black lg:max-w-none">
                                        {aiConsultingFeatures.map((feature) => (
                                            <div
                                                key={feature.name}
                                                className="relative pl-9"
                                            >
                                                <dt className="inline font-semibold text-red-300">
                                                    <feature.icon
                                                        aria-hidden="true"
                                                        className="absolute w-5 h-5 text-red-400 left-1 top-1"
                                                    />
                                                    {feature.name}
                                                </dt>{' '}
                                                <dd className="inline">
                                                    {feature.description}
                                                </dd>
                                            </div>
                                        ))}
                                    </dl>

                                </div>
                            </div>
                            <div className="flex items-start justify-end lg:order-first">
                                <img
                                    alt="AI 醫師"
                                    src={AI_Consulting}
                                    width={2432}
                                    height={1442}
                                    className="hidden md:block h-[16rem] w-[24rem] md:h-[32rem] md:w-[48rem] mt-16 max-w-none rounded-xl shadow-xl ring-1 ring-gray-400/10"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* 手術關懷 */}
                {/* <div className="py-12 overflow-hidden bg-white">
                    <div className="px-6 mx-auto max-w-7xl lg:px-8">
                        <div className="grid max-w-2xl grid-cols-1 mx-auto gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
                            <div className="lg:pr-8 lg:pt-4">
                                <div className="lg:max-w-lg">
                                    <h2 className="text-base font-semibold leading-7 text-red-400">
                                        免費服務
                                    </h2>
                                    <p className="mt-2 text-3xl font-bold tracking-tight text-black sm:text-4xl">
                                        手術關照
                                    </p>
                                    <p className="mt-6 text-lg leading-8 text-red-300">
                                        沒有熟識的醫師朋友，又擔心醫師會不會好好做手術
                                        ?
                                    </p>
                                    <p className="mt-6 text-lg leading-8 text-gray-600">
                                        沒關係，我們可以接受您的拜託，麻醉醫師會關照手術醫師，確保手術醫師盡心盡力把手術做好，讓你多一份安心。
                                    </p>
                                    <p className="max-w-xl mt-10 space-y-8 text-base leading-7 text-gray-600 lg:max-w-none">
                                        手術醫師和麻醉醫師是手術時的最佳拍檔，沒有其他人比麻醉醫師更熟識手術醫師了。
                                        多一份關心，醫師做手術時肯定會多一份認真
                                        !
                                        <br />
                                    </p>
                                    <p className="max-w-xl mt-10 space-y-8 text-base leading-7 text-red-400 lg:max-w-none">
                                        請注意 :
                                        此功能僅提供給合作之保險業務，請聯繫自己的保險業務員確認是否有與我們合作。
                                    </p>
                                </div>
                            </div>
                            <img
                                alt="Product screenshot"
                                src={surgeryCare}
                                className="hidden md:block h-[16rem] w-[24rem] md:h-[32rem] md:w-[48rem] max-w-none rounded-xl shadow-xl ring-1 ring-gray-300 md:-ml-4 lg:-ml-0"
                            />
                        </div>
                    </div>
                </div> */}


                <div className="px-6 pt-12 pb-16 mx-auto bg-white md:pt-16 max-w-7xl lg:px-8">
                    <p className="text-3xl font-bold leading-8 tracking-tight text-red-400">
                        麻醉新知
                    </p>
                    <p className="pb-5 text-2xl leading-8 tracking-wider text-red-400">
                        麻醉醫學教授 余黃平 醫師
                    </p>

                    <div className="flex flex-row flex-nowrap">
                        <div className="hidden mr-12 md:block basis-0 md:basis-1/2">
                            <a
                                href="https://www.facebook.com/CrazyForAnesthesia?mibextid=LQQJ4d"
                                target="blank"
                            >
                                <img
                                    src={余黃平}
                                    alt="麻醉醫學教授余黃平醫師的Facebook頁面連結"
                                />
                            </a>
                        </div>

                        <div className="grow" style={{ overflow: 'auto' }}>
                            <iframe
                                src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FCrazyForAnesthesia%3Fmibextid%3DLQQJ4d&tabs=timeline&width=500&height=400&small_header=true&adapt_container_width=true&hide_cover=true&show_facepile=true&appId"
                                width="500"
                                height="400"
                                style={{ border: 'none', overflow: 'auto' }}
                                // scrolling="no"
                                // frameBorder="0"
                                allowFullScreen={true}
                                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                            ></iframe>
                        </div>
                    </div>
                </div>


                <div className="pb-12 overflow-hidden bg-white">
                    <div className="px-6 mx-auto max-w-7xl lg:px-8">
                        <p className="text-3xl font-bold leading-8 tracking-tight text-red-400">
                            影音副頻道
                        </p>
                        <p className="py-3 text-base tracking-wider">
                            麻辣話麻醉 限制級內容
                        </p>
                        <div className="flex justify-center">
                            <Carousel
                                elements={subVideoList.map(
                                    (video) =>
                                        `<video controls >
                                        <source src="${video}" type="video/mp4" />
                                    </video>`
                                )}
                                width={100}
                                height={80}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Mobile */}
            <div className="block sm:hidden">{/*  */}
                <div className="overflow-hidden bg-white mt-16">
                    <div className="px-5 mx-auto max-w-7xl lg:px-8">
                        <h2 className="text-base font-semibold leading-7 text-red-400">
                            更多資訊
                        </h2>
                        <Link to="https://www.youtube.com/@sharewithdoctors">
                            <p className="flex items-center text-3xl font-bold leading-8 tracking-tight text-red-400">
                                醫同分享
                                <ArrowTopRightOnSquareIcon className="w-8 h-8" />
                            </p>
                        </Link>
                        <p className="py-3 text-base tracking-wider">
                            請至醫同分享Youtube 觀看更多醫藥健康知識
                        </p>

                        <div className="flex justify-center">
                            <Carousel
                                elements={videos.map(
                                    (video) =>
                                        ` 
                                    <div className="w-screen h-screen">
                                        <iframe src=${video.url}
                                            width="320" height="270" 
                                            title="YouTube video player"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        >
                                        </iframe>
                                    </div>
                                    `
                                )}
                                width={100}
                                height={90}
                            />
                        </div>
                    </div>
                </div>

                {/* AI 智能醫師 */}
                <div className="mt-12 overflow-hidden bg-white">
                    <div className="px-6 mx-auto max-w-7xl lg:px-8">
                        <div className="grid max-w-2xl grid-cols-1 mx-auto gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
                            <div className="lg:ml-auto lg:pl-4 lg:pt-4">
                                <div className="lg:max-w-lg">
                                    <p className="mt-2 text-3xl font-bold tracking-tight text-red-400 sm:text-4xl">
                                        免費服務{' '}
                                    </p>
                                    <h2 className="text-lg font-semibold text-red-400">
                                        請聯繫你的保險業務員
                                    </h2>

                                    <h2 className="mt-12 text-2xl font-semibold text-red-400">
                                        免費AI醫師諮詢
                                    </h2>
                                    <h2 className="text-sm font-semibold">
                                        他客觀、坦白、正直、可信賴
                                    </h2>
                                    <Disclosure
                                        key='使用說明'
                                        as="div"
                                        className="border border-red-200 rounded-lg"
                                    >
                                        <dt>
                                            {/* <Disclosure.Button className="flex w-full justify-between rounded-lg bg-purple-100 px-4 py-2 text-left text-sm font-medium text-purple-900 hover:bg-purple-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500/75">
                                                <span>What is your refund policy?</span>
                                                <ChevronUpIcon
                                                    className={`${open ? 'rotate-180 transform' : ''
                                                        } h-5 w-5 text-purple-500`}
                                                />
                                            </Disclosure.Button> */}

                                            {/* <DisclosureButton className="flex items-start justify-between w-full text-left text-gray-900 group"> */}
                                            <DisclosureButton className="group flex w-full justify-between rounded-lg px-4 py-2 text-left text-sm font-medium bg-red-100 text-red-900 hover:bg-red-200 focus:outline-none focus-visible:ring">
                                                <span className="font-semibold text-base/7">
                                                    使用說明
                                                </span>
                                                <span className="flex items-center ml-6 h-7">
                                                    <PlusSmallIcon
                                                        aria-hidden="true"
                                                        className="size-6 group-data-[open]:hidden"
                                                    />
                                                    <MinusSmallIcon
                                                        aria-hidden="true"
                                                        className="size-6 group-[&:not([data-open])]:hidden"
                                                    />
                                                </span>
                                            </DisclosureButton>
                                        </dt>
                                        <DisclosurePanel
                                            as="dd"
                                            className="pr-12 mt-2 mx-4"
                                        >
                                            <p className="text-gray-600 text-base/7">
                                                1. 請聯繫您的保險業務員，請對方產生諮詢連結給您。<br />
                                                2. 打開連結並登入後，將自動跳到諮詢畫面。<br />
                                                3. 向AI諮詢醫師提問，AI醫師收集到足夠資訊時，我們內部醫療從業人員將協助提問。通常三天內可完成。<br />
                                                4. 醫療從業人員詢問AI醫師完畢後，將把報表回傳給您。<br />
                                                5. 完成! AI 醫師已根據您的輸入，提供客觀、正直、可信賴的建議和資訊。<br />
                                            </p>
                                        </DisclosurePanel>
                                    </Disclosure>

                                    <dl className="max-w-xl mt-6 space-y-8 text-base leading-7 text-black lg:max-w-none">
                                        {aiConsultingFeatures.map((feature) => (
                                            <div
                                                key={feature.name}
                                                className="relative pl-9"
                                            >
                                                <dt className="inline font-semibold text-red-300">
                                                    <feature.icon
                                                        aria-hidden="true"
                                                        className="absolute w-5 h-5 text-red-400 left-1 top-1"
                                                    />
                                                    {feature.name}
                                                </dt>{' '}
                                                <dd className="inline">
                                                    {feature.description}
                                                </dd>
                                            </div>
                                        ))}
                                    </dl>
                                </div>
                            </div>
                            <div className="flex items-start justify-end lg:order-first">
                                <img
                                    alt="AI 醫師"
                                    src={AI_Consulting}
                                    width={2432}
                                    height={1442}
                                    className="hidden md:block h-[16rem] w-[24rem] md:h-[32rem] md:w-[48rem] mt-16 max-w-none rounded-xl shadow-xl ring-1 ring-gray-400/10"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* 手術關懷 */}
                {/* <div className="pb-12 overflow-hidden bg-white">
                    <div className="px-6 mx-auto max-w-7xl lg:px-8">
                        <div className="grid max-w-2xl grid-cols-1 mx-auto gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
                            <div className="lg:pr-8 lg:pt-4">
                                <div className="lg:max-w-lg">
                                    <h2 className="text-2xl font-semibold text-red-400">
                                        免費手術關照
                                    </h2>
                                    <h2 className="text-sm font-semibold">
                                        再陌生，我們也會幫忙。
                                    </h2>

                                    <p className="mt-6 text-lg leading-8 text-red-300">
                                        沒有熟識的醫師朋友，又擔心醫師會不會好好做手術
                                        ?
                                    </p>
                                    <p className="leading-8 text-gray-600">
                                        沒關係，我們可以接受您的拜託，麻醉醫師會關照手術醫師，確保手術醫師盡心盡力把手術做好，讓你多一份安心。
                                    </p>
                                    <p className="leading-8 text-gray-600">
                                        手術醫師和麻醉醫師是手術時的最佳拍檔，沒有其他人比麻醉醫師更熟識手術醫師了。
                                        多一份關心，醫師做手術時肯定會多一份認真
                                        !
                                        <br />
                                    </p>
                                    <p className="max-w-xl mt-1 space-y-8 text-base leading-7 text-red-400 lg:max-w-none">
                                        請注意 :
                                        此功能僅提供給合作之保險業務，請聯繫自己的保險業務員確認是否有與我們合作。
                                    </p>
                                </div>
                            </div>
                            <img
                                alt="Product screenshot"
                                src={surgeryCare}
                                className="hidden md:block h-[16rem] w-[24rem] md:h-[32rem] md:w-[48rem] max-w-none rounded-xl shadow-xl ring-1 ring-gray-300 md:-ml-4 lg:-ml-0"
                            />
                        </div>
                    </div>
                </div> */}

                <div className="px-6 pt-12 mx-auto bg-white max-w-7xl lg:px-8">
                    <p className="text-3xl font-bold leading-8 tracking-tight text-red-400">
                        麻醉新知
                    </p>
                    <p className="pb-5 text-lg leading-8 tracking-wider text-red-400">
                        麻醉醫學教授 余黃平 醫師
                    </p>

                    <div className="">
                        <div className="">
                            <a
                                href="https://www.facebook.com/CrazyForAnesthesia?mibextid=LQQJ4d"
                                target="blank"
                            >
                                <img
                                    src={余黃平}
                                    alt="麻醉醫學教授余黃平醫師的Facebook頁面連結"
                                />
                            </a>
                        </div>
                    </div>
                </div>



                <div className="py-12 overflow-hidden bg-white">
                    <div className="px-6 mx-auto max-w-7xl lg:px-8">
                        <p className="text-3xl font-bold leading-8 tracking-tight text-red-400">
                            影音副頻道
                        </p>
                        <p className="py-3 text-base tracking-wider">
                            麻辣話麻醉 限制級內容
                        </p>
                        <div className="flex justify-center">
                            <Carousel
                                elements={subVideoList.map(
                                    (video) =>
                                        `<video controls >
                                        <source src="${video}" type="video/mp4" />
                                    </video>`
                                )}
                                width={100}
                                height={80}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="relative pt-4 pb-6 bg-white isolate sm:pt-6">
                <div
                    className="absolute inset-x-0 overflow-hidden -translate-y-1/2 top-1/2 -z-10 transform-gpu opacity-30 blur-3xl"
                    aria-hidden="true"
                >
                    <div
                        className="ml-[max(50%,38rem)] aspect-[1313/771] w-[82.0625rem] bg-gradient-to-tr from-[#d65846] to-[#f5d5d5]"
                        style={{
                            clipPath:
                                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                        }}
                    />
                </div>
                <div
                    className="absolute inset-x-0 top-0 flex overflow-hidden opacity-25 -z-10 transform-gpu blur-3xl sm:pt-40 xl:justify-end"
                    aria-hidden="true"
                >
                    <div
                        className="ml-[-22rem] aspect-[1313/771] w-[82.0625rem] flex-none origin-top-right rotate-[30deg] bg-gradient-to-tr from-[#d65846] to-[#f5d5d5] xl:ml-0 xl:mr-[calc(50%-12rem)]"
                        style={{
                            clipPath:
                                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                        }}
                    />
                </div>

                <div className="px-6 mx-auto max-w-7xl lg:px-8">
                    <div className="mx-auto ">
                        <h2
                            id="reviews"
                            className="text-3xl font-bold leading-8 tracking-tight text-red-400"
                        >
                            好評推薦
                        </h2>
                    </div>
                    <div className="grid max-w-2xl grid-cols-1 grid-rows-1 gap-8 mx-auto mt-12 text-sm leading-6 text-gray-900 sm:mt-20 sm:grid-cols-2 xl:mx-0 xl:max-w-none xl:grid-flow-col xl:grid-cols-4">
                        <figure className="bg-white shadow-lg rounded-2xl ring-1 ring-gray-900/5 sm:col-span-2 xl:col-start-2 xl:row-end-1">
                            <blockquote className="p-6 text-lg font-semibold leading-7 tracking-tight text-gray-900 sm:p-12 sm:text-xl sm:leading-8">
                                <p>{`"${featuredTestimonial.body}"`}</p>
                            </blockquote>
                            <figcaption className="flex flex-wrap items-center px-6 py-4 border-t gap-x-4 gap-y-4 border-gray-900/10 sm:flex-nowrap">
                                <img
                                    className="flex-none object-cover w-16 h-16 rounded-full bg-gray-50"
                                    src={featuredTestimonial.author.imageUrl}
                                    alt=""
                                />
                                <div className="flex-auto text-base">
                                    <div className="text-gray-600">
                                        {featuredTestimonial.author.handle}
                                    </div>
                                    <div className="font-semibold">
                                        {featuredTestimonial.author.name}
                                    </div>
                                </div>
                            </figcaption>
                        </figure>
                        {testimonials.map((columnGroup, columnGroupIdx) => (
                            <div
                                key={columnGroupIdx}
                                className="space-y-8 xl:contents xl:space-y-0"
                            >
                                {columnGroup.map((column, columnIdx) => (
                                    <div
                                        key={columnIdx}
                                        className={classNames(
                                            (columnGroupIdx === 0 &&
                                                columnIdx === 0) ||
                                                (columnGroupIdx ===
                                                    testimonials.length - 1 &&
                                                    columnIdx ===
                                                    columnGroup.length - 1)
                                                ? 'xl:row-span-2'
                                                : 'xl:row-start-1',
                                            'space-y-8'
                                        )}
                                    >
                                        {column.map((testimonial) => (
                                            <figure
                                                key={testimonial.author.handle}
                                                className="p-6 text-base bg-white shadow-lg rounded-2xl ring-1 ring-gray-900/5"
                                            >
                                                <blockquote className="text-gray-900">
                                                    <p>{`"${testimonial.body}"`}</p>
                                                </blockquote>
                                                <figcaption className="flex items-center pt-5 mt-6 border-t gap-x-4 border-gray-900/10">
                                                    <img
                                                        className="object-cover rounded-full w-14 h-14 bg-gray-50"
                                                        src={
                                                            testimonial.author
                                                                .imageUrl
                                                        }
                                                        alt=""
                                                    />
                                                    <div>
                                                        <div className="text-gray-600">
                                                            {
                                                                testimonial
                                                                    .author
                                                                    .handle
                                                            }
                                                        </div>
                                                        <div className="font-semibold">
                                                            {
                                                                testimonial
                                                                    .author.name
                                                            }
                                                        </div>
                                                    </div>
                                                </figcaption>
                                            </figure>
                                        ))}
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>

                <div className="py-8 mt-12 overflow-hidden bg-white">
                    <div className="px-6 py-12 mx-auto max-w-7xl sm:py-16 lg:px-8">
                        <div className="max-w-4xl mx-auto divide-y divide-gray-900/10">
                            <h2 className="text-3xl font-bold tracking-tight text-red-400">
                                常見問題
                            </h2>
                            <dl className="mt-10 space-y-6 divide-y divide-gray-900/10">
                                {faqs.map((faq) => (
                                    <Disclosure
                                        key={faq.question}
                                        as="div"
                                        className="pt-6"
                                    >
                                        <dt>
                                            <DisclosureButton className="flex items-start justify-between w-full text-left text-gray-900 group">
                                                <span className="font-semibold text-base/7">
                                                    {faq.question}
                                                </span>
                                                <span className="flex items-center ml-6 h-7">
                                                    <PlusSmallIcon
                                                        aria-hidden="true"
                                                        className="size-6 group-data-[open]:hidden"
                                                    />
                                                    <MinusSmallIcon
                                                        aria-hidden="true"
                                                        className="size-6 group-[&:not([data-open])]:hidden"
                                                    />
                                                </span>
                                            </DisclosureButton>
                                        </dt>
                                        <DisclosurePanel
                                            as="dd"
                                            className="pr-12 mt-2"
                                        >
                                            <p className="text-gray-600 text-base/7">
                                                {faq.answer}
                                            </p>
                                        </DisclosurePanel>
                                    </Disclosure>
                                ))}
                            </dl>
                        </div>
                    </div>

                    {/* 麻醉安全小教室 section */}
                    <div className="px-6 py-8 mx-auto max-w-7xl">
                        <div className="max-w-4xl mx-auto divide-y divide-gray-900/10">
                            <h2 className="text-3xl font-bold tracking-tight text-red-400">
                                麻醉安全小教室
                            </h2>
                            <dl className="mt-10 space-y-6 divide-y divide-gray-900/10">
                                {factsOfAnesthToShow.map((fact) => (
                                    <Disclosure
                                        key={fact.question}
                                        as="div"
                                        className="pt-6"
                                    >
                                        <dt>
                                            <DisclosureButton className="flex items-start justify-between w-full text-left text-gray-900 group">
                                                <span className="font-semibold text-base/7">
                                                    {fact.question}
                                                </span>
                                                <span className="flex items-center ml-6 h-7">
                                                    <PlusSmallIcon
                                                        aria-hidden="true"
                                                        className="size-6 group-data-[open]:hidden"
                                                    />
                                                    <MinusSmallIcon
                                                        aria-hidden="true"
                                                        className="size-6 group-[&:not([data-open])]:hidden"
                                                    />
                                                </span>
                                            </DisclosureButton>
                                        </dt>
                                        <DisclosurePanel
                                            as="dd"
                                            className="pr-12 mt-2"
                                        >
                                            <p className="text-gray-600 text-base/7">
                                                {fact.answer}
                                            </p>
                                        </DisclosurePanel>
                                    </Disclosure>
                                ))}
                            </dl>
                            <div className="grid w-full mt-6 justify-items-center">
                                <button
                                    type="button"
                                    className="inline-flex items-center gap-x-1.5 rounded-md 
                                            bg-red-300 px-3 py-2 text-sm font-semibold text-white 
                                            shadow-sm hover:bg-red-400 focus-visible:outline 
                                            focus-visible:outline-2 focus-visible:outline-offset-2 
                                            focus-visible:outline-red-400"
                                    onClick={() =>
                                        setShowAllFacts(!showAllFacts)
                                    }
                                >
                                    {showAllFacts
                                        ? '摺疊全部資訊'
                                        : '顯示全部資訊'}
                                    {showAllFacts ? (
                                        <ChevronDoubleUpIcon
                                            className="w-5 h-5 ml-1"
                                            aria-hidden="true"
                                        />
                                    ) : (
                                        <ChevronDoubleDownIcon
                                            className="w-5 h-5 ml-1"
                                            aria-hidden="true"
                                        />
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <main className="isolate">
                {/* Hero section */}
                <div className="relative isolate -z-10">
                    <svg
                        className="absolute inset-x-0 top-0 -z-10 h-[64rem] w-full stroke-gray-200 [mask-image:radial-gradient(32rem_32rem_at_center,white,transparent)]"
                        aria-hidden="true"
                    >
                        <defs>
                            <pattern
                                id="1f932ae7-37de-4c0a-a8b0-a6e3b4d44b84"
                                width={200}
                                height={200}
                                x="50%"
                                y={-1}
                                patternUnits="userSpaceOnUse"
                            >
                                <path d="M.5 200V.5H200" fill="none" />
                            </pattern>
                        </defs>
                        <svg
                            x="50%"
                            y={-1}
                            className="overflow-visible fill-gray-50"
                        >
                            <path
                                d="M-200 0h201v201h-201Z M600 0h201v201h-201Z M-400 600h201v201h-201Z M200 800h201v201h-201Z"
                                strokeWidth={0}
                            />
                        </svg>
                        <rect
                            width="100%"
                            height="100%"
                            strokeWidth={0}
                            fill="url(#1f932ae7-37de-4c0a-a8b0-a6e3b4d44b84)"
                        />
                    </svg>
                    <div
                        className="absolute top-0 right-0 -ml-24 overflow-hidden left-1/2 -z-10 transform-gpu blur-3xl lg:ml-24 xl:ml-48"
                        aria-hidden="true"
                    >
                        <div
                            className="aspect-[801/1036] w-[50.0625rem] bg-gradient-to-tr from-[#d65846] to-[#f5d5d5] opacity-30"
                            style={{
                                clipPath:
                                    'polygon(63.1% 29.5%, 100% 17.1%, 76.6% 3%, 48.4% 0%, 44.6% 4.7%, 54.5% 25.3%, 59.8% 49%, 55.2% 57.8%, 44.4% 57.2%, 27.8% 47.9%, 35.1% 81.5%, 0% 97.7%, 39.2% 100%, 35.2% 81.4%, 97.2% 52.8%, 63.1% 29.5%)',
                            }}
                        />
                    </div>
                    <div className="overflow-hidden">
                        <div className="px-6 pt-6 pb-32 mx-auto max-w-7xl sm:pt-60 lg:px-8 lg:pt-32">
                            <div className="max-w-2xl mx-auto gap-x-14 lg:mx-0 lg:flex lg:max-w-none lg:items-center">
                                <div className="w-full max-w-xl lg:shrink-0 xl:max-w-2xl">
                                    <h1
                                        id="about"
                                        className="text-2xl font-bold tracking-tight text-red-400 sm:text-3xl"
                                    >
                                        關於我們
                                    </h1>
                                    <p className="relative mt-6 text-lg leading-8 text-gray-600 sm:max-w-md lg:max-w-none">
                                        「麻醉安全通」源起於其前身「FB麻醉安全特別偵查組粉絲專頁」，係由一群台灣麻醉專科醫師於2025年所建構的「醫院外專業第三人麻醉安全評價機制」網路媒體平台。「麻醉安全通」致力於教育及宣導台灣社會大眾相關麻醉醫療常識、提升台灣病人麻醉安全和維護病人醫療權益。
                                    </p>
                                    <p className="relative mt-6 text-lg leading-8 text-gray-600 sm:max-w-md lg:max-w-none">
                                        「麻醉安全通」提供病人查詢台灣各級醫院診所的麻醉安全評價，以確保病人手術時的麻醉安全，盡可能避免麻醉意外發生，甚至是死亡或變成植物人。
                                    </p>
                                    <h1
                                        id="disclaimer"
                                        className="pt-5 text-2xl font-bold tracking-tight text-red-400 sm:text-3xl"
                                    >
                                        免責聲明
                                    </h1>
                                    <p className="relative mt-6 text-lg leading-8 text-gray-600 sm:max-w-md lg:max-w-none">
                                        「麻醉安全通」立於「醫院外麻醉專業第三人」地位評價醫院診所麻醉安全，所有查詢醫院診所麻醉安全評價結果僅供查詢人參考。關於該查詢的醫院診所其實際麻醉醫療服務安全與否，直接或間接使用「麻醉安全通」人應自行再次審慎評估與斟酌，「麻醉安全通」不負麻醉安全保證責任。又醫療行為本身存在不確定性與一定風險，「麻醉安全通」之直接或間接使用人與各醫院診所因麻醉所發生之任何醫療糾紛，「麻醉安全通」不負任何法律上之責任。
                                    </p>
                                </div>

                                <div className="flex justify-end gap-8 mt-14 sm:-mt-44 sm:justify-start sm:pl-20 lg:mt-0 lg:pl-0">
                                    <div className="flex-none pt-32 ml-auto space-y-8 w-44 sm:ml-0 sm:pt-80 lg:order-last lg:pt-36 xl:order-none xl:pt-80">
                                        <div className="relative">
                                            <img
                                                src={about1}
                                                alt=""
                                                className="aspect-[2/3] w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
                                            />
                                            <div className="absolute inset-0 pointer-events-none rounded-xl ring-1 ring-inset ring-gray-900/10" />
                                        </div>
                                    </div>
                                    <div className="flex-none mr-auto space-y-8 w-44 sm:mr-0 sm:pt-52 lg:pt-36">
                                        <div className="relative">
                                            <img
                                                src={about2}
                                                alt=""
                                                className="aspect-[2/3] w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
                                            />
                                            <div className="absolute inset-0 pointer-events-none rounded-xl ring-1 ring-inset ring-gray-900/10" />
                                        </div>
                                        <div className="relative">
                                            <img
                                                src={about3}
                                                alt=""
                                                className="aspect-[2/3] w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
                                            />
                                            <div className="absolute inset-0 pointer-events-none rounded-xl ring-1 ring-inset ring-gray-900/10" />
                                        </div>
                                    </div>
                                    <div className="flex-none pt-32 space-y-8 w-44 sm:pt-0">
                                        <div className="relative">
                                            <img
                                                src={about4}
                                                alt=""
                                                className="aspect-[2/3] w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
                                            />
                                            <div className="absolute inset-0 pointer-events-none rounded-xl ring-1 ring-inset ring-gray-900/10" />
                                        </div>
                                        <div className="relative">
                                            <img
                                                src={about5}
                                                alt=""
                                                className="aspect-[2/3] w-full rounded-xl bg-gray-900/5 object-cover shadow-lg"
                                            />
                                            <div className="absolute inset-0 pointer-events-none rounded-xl ring-1 ring-inset ring-gray-900/10" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            <div className="flex items-center justify-center">
                <h2
                    id="share"
                    className="text-3xl font-bold leading-8 tracking-tight text-red-400"
                >
                    好友分享
                </h2>
            </div>
            <div className="flex items-center justify-center">
                <img className="w-auto h-70" src={qr} alt="" />
            </div>
            <Footer />
        </>
    )
}
